<template>
  <div class="col" :style="props.itemStyle || ''">
    <div class="list-group card-item" style="border-radius: 1.2rem;" v-touch:press="onTouchDown" v-touch:drag="onTouchDrag" v-touch:release="onTouchRelease" v-touch:hold="onTouchHold">
      <div class="list-group-item d-flex align-items-center" :style="`height: 4rem; padding: 2px 0px; background: #ffe082;`">
      <!-- <div class="list-group-item d-flex align-items-center" :style="`height: 4rem; padding: 2px 0px; background: ${curtainStatus == 1 ? '#ffe082' : (curtainStatus == 0 ? 'inherits' : '#fff8e1')};`"> -->
        <img :src="require('@/assets/images/curtain.svg')" style="margin-right: 0.4rem; height: 13px; width: 13px; margin-top: -2px;" class="ms-3 me-2" />
        <div class="flex-fill" style="font-size: 0.8rem">
          {{ curtainDevices.length > 1 ? '커튼' : curtainDevices[0].name }}
          <br>
          {{ currentStateText }}
        </div>
        <div class="mx-0 h-100" style="border-radius: 10px 0px 0px 10px; border: 1px solid #ffc082; border-right: 0px solid #ffc082; background-color: #ffd082;" @click.stop="onCurtainPowerClicked(MQTTCurtainCommand.IsOpen)">
          <div style="margin-top: 21px; width:40px; text-align: center;">열기</div>
        </div>
        <div class="mx-0 h-100" style="border: 1px solid #ffc082; border-right: 0px solid #ffc082; background-color: #ffd082;" @click.stop="onCurtainPowerClicked(MQTTCurtainCommand.IsStop)" >
          <div style="margin-top: 21px; width:40px; text-align: center;">멈춤</div>
        </div>
        <div class="mx-0 h-100" style="border-radius: 0px 10px 10px 0px; border: 1px solid #ffc082; background-color: #ffd082;" @click.stop="onCurtainPowerClicked(MQTTCurtainCommand.IsClose)">
          <div style="margin-top: 21px; width:40px; text-align: center;">닫기</div>
        </div>
        <div
          v-if="curtainDevices.length <= 1"
          class="mx-0 h-100"
          @click.stop="onSettingClicked"
          style="border-radius: 0rem 1.2rem 1.2rem 0rem;"
        >
          <i class="fa-solid fa-gear" style="font-size: 0.8rem; margin-top: 24px; width:40px; text-align: center" />
        </div>
        <div v-if="curtainDevices.length > 1" style="min-width:1px; height: 20px; border-left: 1px solid #ffd082;" />
        <div class="mx-0 h-100" v-if="curtainDevices.length > 1" @click.stop="onExpandClicked" style="border-radius: 0rem 1.2rem 1.2rem 0rem;">
          <i :class="`fa ${isExpand ? 'fa-chevron-up' : 'fa-chevron-down'}`" style="font-size: 0.8rem; margin-top: 24px; width:40px; text-align: center" />
        </div>
      </div>
    </div>
    <transition name="fade">
      <div v-if="isExpand && curtainDevices.length > 1">
        <RoomCurtainDeviceItem v-for="(device, index) in realDevices" :key="device._id" :roomName="props.roomName" :roomId="props.roomId" :deviceId="device._id" :index="index" />
        <RoomCurtainDeviceItem v-for="(device, index) in virtualDevices" :key="device._id" :roomName="props.roomName" :roomId="props.roomId" :deviceId="device._id" :index="index" />
      </div>
    </transition>
  </div>
        
  <!-- v-if 금지: 물리버튼 할당 대기 중 모달 닫아도 컴포넌트·watch/타이머 유지 (LightDeviceItemModal과 동일) -->
  <CurtainItemModal
    :visible="curtainItemModal.visible"
    :cancelCallback="curtainItemModal.hide"
    :roomName="props.roomName"
    :roomId="props.roomId"
    :handlePowerClick="onCurtainPowerClicked"
  />
</template>

<script setup>
import { reactive, defineProps, getCurrentInstance, computed, ref } from 'vue';
import { useStore } from 'vuex';
import { ButtonConfig, DeviceType, PowerState, MQTTTempCommand, MQTTCurtainCommand, MQTTDooyaRonoCommand, getDooyaRonoCtrlData } from '@/common/constants';
import CurtainItemModal from './CurtainItemModal.vue';
import useModal from '@/common/hooks/useModal';
import useMqttControl from '@/common/hooks/useMqttControl';
import useDeviceTouch from '@/common/hooks/useDeviceTouch';
import RoomCurtainDeviceItem from './RoomCurtainDeviceItem.vue';
import Axios, { DeviceApi } from '@/api';
import {
  syncCurtainLinkedLights,
  linkedLightsTurnOnForCurtainCommand,
} from '@/common/utils/curtainLinkedLights';

const { emit } = getCurrentInstance();
const mqttControl = reactive(useMqttControl());
const props = defineProps(['roomId', 'roomName']);
const store = useStore();
const curtainItemModal = reactive(useModal());
const { emitter } = getCurrentInstance().appContext.config.globalProperties;
const { 
  handlePower, 
  handleTouchDown, 
  handleTouchDrag, 
  handleTouchRelease,
  handleTouchHold
} = useDeviceTouch(props.roomId);
const isExpand = ref(false);

const zone = computed(() => {
  if (store.state.home.zones.length > 0) {
    return store.getters['home/getCurrentZone'];
  } else return null;
});
const group = computed(() => {
  return zone.value.groups.find((g) => g._id === props.roomId);
});
const devices = computed(() => {
  return group.value ? group.value.devices : undefined;
});

const curtainDevices = computed(() => {
  return devices.value.filter(
    (d) => d.type === 3 || d.type === 5 || d.type === 6,
  );
});
const realDevices = computed(() => {
  return devices.value.filter(
    (d) => (d.type === 3 || d.type === 5 || d.type === 6) && !d.isVirtual,
  );
});
const virtualDevices = computed(() => {
  return devices.value.filter(
    (d) => (d.type === 3 || d.type === 5 || d.type === 6) && d.isVirtual,
  );
});

const getPower = computed(() => {
  return realDevices.value.some((d) => d.item?.close == PowerState.On);
});

const currentStateText = computed(() => {
  return '';
  return getPower.value ? "닫힘" : "열림";
});

const deviceState = (type) => {
  return devices.value
    .filter((d) => d.type == type)
    .some((d) => d.item.close == PowerState.On);
};

const requestUpdateDevice = async (id, params) => {
  return new Promise(async (resolve, reject) => {
    try {
      const result = await Axios.patch(DeviceApi.UPDATE_DEVICE.replace(':id', id), params);
      if (result.resultCode === '0000') {
        console.log(result);
        store.commit('home/updateDevice', {
          groupId: group.value._id,
          id,
          data: params,
        });
        resolve(result);
      } else {
        emitter.emit('showPopAlert', {
          description: result.resultMessage,
        });
        reject(result.resultMessage);
      }
    } catch (error) {
      emitter.emit('showPopAlert', {
        description: '장치 정보 수정에 실패했습니다.',
      });
      reject('장치 정보 수정에 실패했습니다.');
    }
  });
};

const onCurtainPowerClicked = (command) => {
  if (!command) {
    return;
  }

  emitter.emit('showLoading');
  (async () => {
    try {
      const linkedTurnOn = linkedLightsTurnOnForCurtainCommand(command);
      await Promise.all(realDevices.value.map(async (device) => {
        if (device.type == 3) {
          mqttControl.onPublishTemp(device.controllerId, command, `${device.item.address}`);
        } else if (device.type == 5) {
          mqttControl.onPublish(device.controllerId, device._id, {
            cmd: MQTTDooyaRonoCommand.DooyaCtrl,
            type: 1,
            data: getDooyaRonoCtrlData(device.item, command),
          });
        } else if (device.type == 6) {
          mqttControl.onPublish(device.controllerId, device._id, {
            cmd: MQTTDooyaRonoCommand.RonoCtrl,
            type: 1,
            data: getDooyaRonoCtrlData(device.item, command),
          });
        }
        await requestUpdateDevice(device._id, {
          item: { close: getPower.value ? 0 : 1 }
        });
        if (linkedTurnOn != null) {
          await syncCurtainLinkedLights({
            mqttControl,
            store,
            curtainId: device._id,
            turnOn: linkedTurnOn,
          });
        }
      }));
      setTimeout(() => emitter.emit('hideLoading'), realDevices.value.length > 1 ? ButtonConfig.delayBatch : ButtonConfig.delay);
    } catch (err) {
      emitter.emit('hideLoading');
    }
  })();
};

const onSettingClicked = (e) => {
  curtainItemModal.show();
}

const onExpandClicked = (e) => {
  isExpand.value = !isExpand.value;
}

const onTouchDown = (e) => {
  if (deviceState(2)) {
    handleTouchDown(e);
  }
}

const onTouchDrag = (e) => {
  handleTouchDrag(e, (screenX, startX) => {
    // percent.value = percent.value + (screenX - startX) / boilerItem.value.clientWidth * 100.0;
    // percent.value = percent.value <= 0 ? 0 : percent.value;
    // percent.value = percent.value >= 100 ? 100 : percent.value;
    // targetTemp.value = parseInt(percent.value  * 0.27) + 9;
  });
}

const onTouchRelease = (e) => {
  handleTouchRelease(e, () => {});
}

const onTouchHold = (e) => {
  if (curtainDevices.value.length > 1) {
    return;
  }
  handleTouchHold(e, onSettingClicked);
}
</script>

<style scoped>
.card-item {
  background-color: #ffffff;
  border: 1px solid #e9ecef;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.card-item:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  transform: translateY(-2px);
}
</style>